<template>
    <div>
        <a href="#" class="alink" color="success" @click="reset">
            <v-icon color="success">mdi-plus-circle</v-icon>Add New Student
        </a>
        <v-dialog
            v-model="dialog"
            persistent
            max-width="800px"
            transition="dialog-bottom-transition"
            v-if="newform">
            <v-card>
                <v-card-title class="modal-card-title text-h6 font-weight-bold">
                <v-icon left>mdi-account-plus</v-icon>
                <span v-if="!editBtn">Create Student</span>
                <span v-else>Update Student</span>
                <v-spacer></v-spacer>
                <v-btn icon class="modal-close-btn" @click="closeDialog">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                </v-card-title>

                <v-card-text class="pt-6">
                    <v-form v-model="valid" ref="form">
                        <v-container>
                            <v-row>                                        
                                <v-col
                                cols="12"
                                md="4"
                                >
                                    <v-text-field
                                        outlined
                                        v-model="form.surname"
                                        label="Surname"
                                        :rules="[v => !!v || 'Surname is required']"
                                        required
                                    ></v-text-field>
                                    <v-text-field
                                        outlined
                                        v-model="form.firstname"
                                        label="First Name"
                                        :rules="[v => !!v || 'First Name is required']"
                                        required
                                    ></v-text-field>
                                    <v-text-field
                                        outlined
                                        v-model="form.middlename"
                                        label="Middle Name (optional)"
                                    ></v-text-field>
                                </v-col>
                                <v-col
                                cols="12"
                                md="4"
                                >
                                    <v-select
                                        v-model="form.gender"
                                        outlined
                                        :items="gender"
                                        item-text="name"
                                        item-value="id"
                                        label="Gender (optional)"
                                    ></v-select>
                                    <v-select
                                        v-model="form.clasx_id"
                                        v-if="!editBtn"
                                        outlined
                                        :items="classes"
                                        item-text="class"
                                        item-value="class_id"
                                        label="Current Class"
                                        :rules="[v => !!v || 'Class is required']"
                                        required
                                    ></v-select>
                                    <v-select
                                        v-model="form.status"
                                        v-else
                                        outlined
                                        :items="['active','inactive']"
                                        label="Select Inactive if student left school"
                                    ></v-select>
                                    <v-select
                                        v-model="form.year_admitted"
                                        outlined
                                        :items="years"
                                        :rules="[v => !!v || 'Year admitted is required']"
                                        required
                                        label="Year Admitted"
                                    ></v-select>
                                </v-col>
                                <v-col
                                cols="12"
                                md="4"
                                >
                                <v-menu
                                        v-model="menu2"
                                        :close-on-content-click="false"
                                        :nudge-right="40"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="auto"
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field
                                                v-model="form.dob"
                                                outlined
                                                label="Date of Birth (optional)"
                                                append-icon="mdi-calendar"
                                                readonly
                                                v-bind="attrs"
                                                v-on="on"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker
                                        v-model="form.dob"
                                        @input="menu2 = false"
                                        ></v-date-picker>
                                    </v-menu>
                                    <v-text-field
                                        outlined
                                        v-model="form.fileno"
                                        label="File Number (optional)"
                                        min="0"
                                        type="number"
                                    ></v-text-field>
                                    <v-text-field
                                        outlined
                                        v-model="form.parent_name"
                                        label="Parent Name (optional)"
                                    ></v-text-field>
                                </v-col>                                         
                                <v-col
                                cols="12"
                                md="12"
                                >
                                <img
                                v-if="editBtn"
                                :src="form.passport_view"
                                height="30"/>
                                <v-chip color="yellow"> <strong>Uploading Student Passport is a PREMIUM service that will consume 1 TOKEN</strong></v-chip>
                                <v-file-input
                                    filled
                                    :rules="[value => !value || value.size < 500000 || 'Passport size should be less than 500kb!']"
                                    accept="image/png, image/jpeg, image/jpg"
                                    placeholder="Student Passport (optional)"
                                    prepend-icon="mdi-camera"
                                    label="Student Passport (optional)"
                                    @change="passport = true"
                                ></v-file-input>  
                                <v-chip color="yellow" v-if="editBtn">Current Class: -- <strong> {{form.clasx_id}}</strong>. Moving Student to another class is a &nbsp; <strong>PREMIUM service that will consume 1 TOKEN</strong></v-chip>
                                </v-col>
                                <v-col
                                cols="12"
                                md="6"
                                >
                                <v-select
                                        v-model="form.class_change"
                                        v-if="editBtn"
                                        outlined
                                        :items="['yes', 'no']"
                                        label="Move to Another Class? (Optional)"
                                ></v-select>
                                </v-col>
                                <v-col
                                cols="12"
                                md="6"
                                >
                                <v-select
                                        v-model="form.clasx_id"
                                        v-if="editBtn"
                                        outlined
                                        :items="classes"
                                        item-text="class"
                                        item-value="class_id"
                                        label="Select the Class to move"
                                ></v-select>
                                </v-col>
                                <v-col
                                cols="12"
                                md="12"
                                >
                                <v-btn :disabled="!valid" color="success" rounded elevation="2"
                                class="mr-2 px-6" @click="postRecord" v-if="!editBtn"
                                >
                                    <v-icon left>mdi-check</v-icon>
                                    Create
                                </v-btn>
                                <v-btn :disabled="!valid" color="success" rounded elevation="2"
                                class="mr-2 px-6" @click="updateRecord" v-else
                                >
                                    <v-icon left>mdi-check</v-icon>
                                    Update
                                </v-btn>
                                <v-btn outlined rounded @click="closeDialog">
                                    <v-icon left>mdi-close</v-icon>
                                    Close
                                </v-btn>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>
                </v-card-text>
            </v-card>
        </v-dialog>

    </div>
</template>
<script>
import axios from 'axios';
  export default {
    name: 'CreateStudentForm',
    props:[
        'authToken',
        'school',
        'editFormSignal',
        'refreshRecordSignal',
        'classes'
    ],
    mounted() {
       this.getStudents()
    },
    data: () => ({
        newform: false,
        editBtn: false,
        form:{},
        years:['2010','2011','2012','2013','2014','2015','2016','2017','2018','2019','2020','2021','2022', '2023', '2024'],
        gender:[
            {id:'0', name:'Male'},
            {id:'1', name:'Female'},
        ],
        menu2:false,
        passport: false,
        students: [],
        valid: true,
        dialog:true
    }),
    watch:{
        editFormSignal(record){
            //console.log(record)
            this.editRecord(record)
        },
        refreshRecordSignal(signal){
            console.log(signal)
            this.getStudents()
        }
    },
    methods: {
        reset () {
            this.newform = true
            this.editBtn = false
            this.form = {}
        },
        closeDialog() {
            this.newform = false;
            this.form.class_change = ""
        },
        getStudents () {
            axios.get(process.env.VUE_APP_BASEURL+'/students?school_id='+this.school.school_id,
            {
                headers: 
                {
                    'Authorization': 'Bearer '+this.authToken
                }
            })
            .then((response) => {
                this.students =  response.data.data
                this.studentCount = response.data.count   
                this.$emit("get_students", this.students); // Emit the event with data             
                this.$emit("get_students_count", this.studentCount); // Emit the event with data             
            })
            .catch((error) => {
                if (error.response.status == 401) {
                    localStorage.removeItem('authToken')
                }
                this.$toast.error(error.response ? error.response.data.message : 'APP is temporarily unavailable. Wait or Contact us!', {
                    timeout: 5000
                });
            })
            .finally(() => {
                this.fetchingContent = false;
            });
        },
        uploadImage (recordId) {
            if (this.passport){
                let formdata = new FormData()
                formdata.append('passport', document.querySelector('input[type=file]').files[0])
                formdata.append('studentId', recordId)
                let loader = this.$loading.show()
                axios.post(process.env.VUE_APP_BASEURL+'/students?school_id='+this.school.school_id,formdata,
                {
                    headers: 
                    {
                        'Authorization': 'Bearer '+this.authToken,
                        'Content-Type' : 'multipart/form-data'
                    }
                })
                .then((response) => {  
                    this.$toast.success(response.data.message, {
                        timeout: 2000
                    });                     
                    this.$store.dispatch('fetchTokens', this.school.school_id); 
                    //this.getStudents()                            
                })
                .catch((error) => {
                    console.log(error)
                })
                .finally(() => {
                    loader.hide()
                });
            }
            this.passport = false
            this.getStudents()   
            this.editBtn = false             
            this.newform = false 
        },
        postRecord () {
            let validation = this.$refs.form.validate()
            if(!validation) {
                return validation
            }
            let loader = this.$loading.show()
            axios.post(process.env.VUE_APP_BASEURL+'/students?school_id='+this.school.school_id,this.form,
            {
                headers: 
                {
                    'Authorization': 'Bearer '+this.authToken
                }
            })
            .then((response) => {
                this.$toast.success(response.data.message, {
                    timeout: 5000
                });
                this.uploadImage(response.data.data.student_id);                
                this.$store.dispatch('fetchTokens', this.school.school_id);             
            })
            .catch((error) => {
                this.$toast.error(error.response ? error.response.data.message : 'Network Error, Please try again few minutes', {
                    timeout: 5000
                });
            })
            .finally(() => {
                loader.hide()
            });
        },
        editRecord (record){
            this.newform = true
            this.form.id = record.student_id
            this.form.surname = record.surname
            this.form.firstname = record.firstname
            this.form.middlename = record.middlename
            this.form.gender = record.gender
            this.form.year_admitted = record.year_admitted
            this.form.dob = record.dob
            this.form.parent_name = record.parent_name
            this.form.fileno = record.fileno
            this.form.status = record.status
            this.form.passport_view = record.passport
            this.form.clasx_id = record.current_class
            this.editBtn = true
        },
        updateRecord () {
            let validation = this.$refs.form.validate()
            if(!validation) {
                return validation
            }
            let loader = this.$loading.show()
            axios.put(process.env.VUE_APP_BASEURL+'/students/'+this.form.id+'?school_id='+this.school.school_id,this.form,
            {
                headers: 
                {
                    'Authorization': 'Bearer '+this.authToken
                }
            })
            .then((response) => {
                this.$toast.success(response.data.message, {
                    timeout: 5000
                }); 
                this.uploadImage(this.form.id)            
            })
            .catch((error) => {
                this.$toast.error(error.response ? error.response.data.message : 'Network Error, Please try again few minutes', {
                    timeout: 5000
                });
            })
            .finally(() => {
                loader.hide()                
                this.form.class_change = ""
            });
        },
    },
  }
</script>
<style scoped>
.alink{
    text-decoration: none;
    font-weight: bolder;
}
</style>